import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppListHeader from '../components/title/AppListHeader'
import TabsMui from '../layout/TabsMui'
import {
  canViewDailySettlementControl,
  canViewSettlements
} from '../global_context/capabilities/settlementCapabilities'
import {
  SETTLEMENT_INDEX_TAB,
  SETTLEMENT_INDEX_TABS,
  SETTLEMENT_INDEX_TEXT,
  SETTLEMENT_ROUTES
} from './constants/constants'
import './settlementsIndex.scss'

// Comparte el encabezado y navega entre las pantallas permitidas, sin arrastrar su paginación.
export default function SettlementsPageLayout({ activeTab, children }) {
  const navigate = useNavigate()
  const permissions = {
    [SETTLEMENT_INDEX_TAB.SETTLEMENTS]: canViewSettlements(),
    [SETTLEMENT_INDEX_TAB.DAILY]: canViewDailySettlementControl()
  }
  const tabs = SETTLEMENT_INDEX_TABS.filter(({ value }) => permissions[value])
  // Sin permiso de Control diario no se monta la barra completa, ni su contenedor.
  const showTabs = permissions[SETTLEMENT_INDEX_TAB.DAILY] && tabs.length > 1

  return (
    <div className="settlements-control-page app-list-shell ubiqua-type">
      <AppListHeader
        title={SETTLEMENT_INDEX_TEXT.TITLE}
        subtitle={SETTLEMENT_INDEX_TEXT.SUBTITLE}
      />
      <div className="index-table app-list-content">
        {showTabs && (
          <TabsMui
            appearance="pill"
            activeTab={activeTab}
            onChange={(value) => navigate(SETTLEMENT_ROUTES[value])}
            scrollable
            ariaLabel={SETTLEMENT_INDEX_TEXT.TABS_ARIA_LABEL}
            tabs={tabs}
          />
        )}
        {children}
      </div>
    </div>
  )
}
